import Button from "./Button";
import DateFilter from "./Date/DateFilter";
import SearchWithDropDown from "./SearchWithDropdown"
import SelectFilter from "./Select";

export function GenericSearchComponent({ config = [], parentClassName }) {
    return (
        <div className={parentClassName}>
            {config.map((item, index) => { // 
                if (item?.type?.toLowerCase() === 'search & dropdown') {
                    return (
                        <SearchWithDropDown
                            key={index}
                            isSearch={true}
                            isDropdown={true}
                            {...item}

                        />
                    );
                }
                if (item?.type?.toLowerCase() === 'search') {
                    return (
                        <SearchWithDropDown
                            key={index}
                            isDropdown={false}
                            isSearch={true}
                            {...item}
                        />
                    );
                }
                if (item?.type?.toLowerCase() === 'dropdown') {
                    return (
                        <SearchWithDropDown
                            key={index}
                            isSearch={false}
                            isDropdown={true}
                            {...item}

                        />
                    );
                }
                if (item?.type?.toLowerCase() === 'date') {
                    return (
                        <DateFilter
                            key={index}
                            {...item}
                        />
                    );
                }
                if (item?.type?.toLowerCase() === 'select') {
                    return (
                        <SelectFilter
                            key={index}
                            {...item}
                        />
                    );
                }
                if (item?.type?.toLowerCase() === 'button') {
                    return (
                        <Button
                            key={index}
                            {...item}
                        />
                    );
                }



                return null;
            })}
        </div>
    );
}
